// extracted by mini-css-extract-plugin
module.exports = {"main":"style_main__9wPpi","icon":"style_icon__3wwn8"};